// extracted by mini-css-extract-plugin
export default {"modal":"SelectTemplateVersion_modal__6+sDj","tips":"SelectTemplateVersion_tips__-uSUW","version":"SelectTemplateVersion_version__6JVDu"};